module.exports = __webpack_public_path__ + "static/media/Afghanistan.e7002cbf.png";